'use strict';

module.exports = () => {
    const $ = jQuery;
    function initSlider($pane) {
        const $slider = $pane.find('.projects__slider');
        const $nav = $pane.find('.projects__nav');

        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 1,
                arrows: true,
                dots: true,
                adaptiveHeight: true,

                appendArrows: $nav,
                appendDots: $nav,

                prevArrow: '<button class="slick-prev custom-arrow"></button>',
                nextArrow: '<button class="slick-next custom-arrow"></button>',
            });
        } else {
            $slider.slick('setPosition');
        }
    }

    const $firstPane = $('.projects__tabs-pane.active');
    initSlider($firstPane);


    $('.projects__tabs-btn').on('click', function () {
        const tabId = $(this).data('tab');

        $('.projects__tabs-btn').removeClass('active');
        $(this).addClass('active');

        $('.projects__tabs-pane').removeClass('active');
        const $activePane = $('.projects__tabs-pane[data-tab="' + tabId + '"]');
        $activePane.addClass('active');

        initSlider($activePane);
    });

    const mobileTabs = document.querySelector('.projects__tabs-mobile');

if (mobileTabs) {

    const current = mobileTabs.querySelector('.projects__tabs-current');

    current.addEventListener('click', () => {
        mobileTabs.classList.toggle('open');
    });

    mobileTabs.querySelectorAll('.projects__tabs-option').forEach(option => {

        option.addEventListener('click', function () {

            current.querySelector('.projects__tabs-current__text').textContent = this.textContent;

            mobileTabs.classList.remove('open');

            document.querySelector(
                `.projects__tabs-btn[data-tab="${this.dataset.tab}"]`
            )?.click();
        });

    });

}

}